import {
  Button,
  Chip,
  Typography,
  Stack,
  Popper,
  ClickAwayListener,
  Paper,
  Link,
} from "@mui/material";
import { useState } from "react";
import AttachmentIcon from "@mui/icons-material/Attachment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description"; // generic doc
import TableChartIcon from "@mui/icons-material/TableChart"; // spreadsheet
import ImageIcon from "@mui/icons-material/Image"; // images
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // fallback
import config from "../../Config/config";

function getFileIcon(type) {
  if (!type) return <InsertDriveFileIcon color="action" />;

  if (type === "application/pdf") return <PictureAsPdfIcon color="error" />;

  if (
    type === "application/msword" ||
    type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return <DescriptionIcon color="primary" />;
  }

  if (
    type === "application/vnd.ms-excel" ||
    type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    type === "text/csv"
  ) {
    return <TableChartIcon color="success" />;
  }

  if (type.startsWith("image/")) {
    return <ImageIcon color="secondary" />;
  }

  return <InsertDriveFileIcon color="action" />;
}

export default function AttachmentModal({ attachments, uid }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleClick}>
        <AttachmentIcon></AttachmentIcon>
      </Button>

      <Popper open={open} anchorEl={anchorEl} placement="left-start">
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 2, boxShadow: 24, borderRadius: 2 }}>
            <Stack spacing={1}>
              {attachments.map((a) => {
                const url = `${config.serverBaseUrl}/projects/attachments/${uid}/${a.uid}/download/${a.original_name}`;
                return (
                  <Link
                    key={a.attachment_id}
                    component="a"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      justifyItems="start"
                      sx={{ minWidth: 0 }}
                    >
                      {getFileIcon(a.mime_type)}
                      <Typography
                        variant="body2"
                        color="text.primary"
                        sx={{ fontWeight: "bold" }}
                      >
                        {a.original_name}
                      </Typography>
                      {a.category && <Chip size="small" label={a.category} />}
                    </Stack>
                  </Link>
                );
              })}
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
